// import ReactDOM from "react-dom/client";
// import App from "./App.jsx";
// import "./index.css";
// import "./i18n.js";
// import { AppContext } from "./context/appContext.js";
// import { useEffect, useState } from "react";
// import remoteConfigService from "./services/remoteConfig/RemoteConfigService.js";

// const Root = () => {
//   const [isMeRewardsLoading, setIsMeRewardsLoading] = useState(false);

//   // fetch & activate remote firebase config
//   useEffect(() => {
//     const activateConfig = async () => {
//       await remoteConfigService.fetchAndActivateConfig();
//       console.log("activating config");
//     };
//     activateConfig();
//   }, []);

//   return (
//     <AppContext.Provider value={{ isMeRewardsLoading, setIsMeRewardsLoading }}>
//       <App />
//     </AppContext.Provider>
//   );
// };

// ReactDOM.createRoot(document.getElementById("root")).render(<Root />);

// --Prerender (SSG) modfied---
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from "./App.jsx";
import "./index.css";
import "./i18n.js";
import { AppContext } from "./context/appContext.js";
import { useEffect, useState } from "react";
import remoteConfigService from "./services/remoteConfig/RemoteConfigService.js";
import { getSeoForPath } from "./seo/pageSeo.js";

export function Root ({url}) {
  const [isMeRewardsLoading, setIsMeRewardsLoading] = useState(false);

  // fetch & activate remote firebase config
  useEffect(() => {
    const activateConfig = async () => {
      await remoteConfigService.fetchAndActivateConfig();
      console.log("activating config");
    };
    activateConfig();
  }, []);

  return (
    <AppContext.Provider value={{ isMeRewardsLoading, setIsMeRewardsLoading }}>
      <App url={url}/>
    </AppContext.Provider>
  );
};

if (typeof window !== 'undefined') {
    const target = document.getElementById('root');
    import.meta.env.DEV ? createRoot(target).render(<Root />) : hydrateRoot(target, <Root />);
}

export async function prerender(data) {
  const { renderToString } = await import("react-dom/server");
  const { parseLinks } = await import("vite-prerender-plugin/parse");

  const html = await renderToString(<Root {...data} />);
  const links = parseLinks(html);
  const head = getSeoForPath(data?.url || "/");

  return { html, links, head };
}
